export default __webpack_public_path__ + "static/media/handycap02-1.5ee6824f.png";